import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import './DTBuscador.css';
import DTResultados from './DTResultados';

const initialRows = [
  { nombre: 'Document Status', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Código Barras', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Código Aduana', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Número de viaje', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Fecha de salida', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Referencia D/T', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Referencia D/T padre', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Lugar de embarque', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Lugar de desembarque', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Nombre Consignatario', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Uso', criterios: 'todo', valor1: '', valor2: '' },
  { nombre: 'Indicador Dividir', criterios: 'todo', valor1: '', valor2: '' },
];

function DTBuscador({ onClose, savedDTs = [] }) {
  const [rows, setRows] = useState(initialRows);
  const [showResultados, setShowResultados] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: null, y: null });
  const dragOffset = useRef({ x: 0, y: 0 });
  const dialogRef = useRef(null);

  const handleMouseDown = (e) => {
    if (dialogRef.current) {
      const rect = dialogRef.current.getBoundingClientRect();
      dragOffset.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
      setIsDragging(true);
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - dragOffset.current.x,
        y: e.clientY - dragOffset.current.y,
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleCellChange = (index, field, value) => {
    const updated = [...rows];
    updated[index] = { ...updated[index], [field]: value };
    setRows(updated);
  };

  const style = position.x !== null
    ? { left: position.x, top: position.y, transform: 'none' }
    : {};

  return ReactDOM.createPortal(
    <div
      className="dt-buscador-overlay"
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <div className="dt-buscador-window" ref={dialogRef} style={style}>
        {/* Barra de título */}
        <div className="dt-buscador-titlebar" onMouseDown={handleMouseDown}>
          <span className="dt-buscador-title">D/T buscador</span>
          <button className="dt-buscador-close" onClick={onClose}>×</button>
        </div>

        {/* Mensaje informativo */}
        <div className="dt-buscador-info">
          <span className="dt-buscador-info-icon">ℹ️</span>
          <span className="dt-buscador-info-text">
            Por favor introduzca los datos para el criterio de selección, y proceda a buscar un documento específico D/T
          </span>
        </div>

        {/* Tabla de criterios */}
        <div className="dt-buscador-table-container">
          <table className="dt-buscador-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>criterios</th>
                <th>valor #1</th>
                <th>valor #2</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.nombre}>
                  <td className="dt-buscador-nombre">{row.nombre}</td>
                  <td className="dt-buscador-criterios">
                    <select
                      className="dt-buscador-select"
                      value={row.criterios}
                      onChange={(e) => handleCellChange(i, 'criterios', e.target.value)}
                    >
                      <option value="todo">todo</option>
                      <option value="comienza con">comienza con</option>
                      <option value="termina con">termina con</option>
                      <option value="contiene la subcadena">contiene la subcadena</option>
                      <option value="iguales">iguales</option>
                      <option value="expression">expression</option>
                      <option value="esta vacío">esta vacío</option>
                      <option value="no esta vacío">no esta vacío</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="text"
                      className="dt-buscador-input"
                      value={row.valor1}
                      onChange={(e) => handleCellChange(i, 'valor1', e.target.value)}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="dt-buscador-input"
                      value={row.valor2}
                      onChange={(e) => handleCellChange(i, 'valor2', e.target.value)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Botones de acción */}
        <div className="dt-buscador-actions">
          <button className="dt-buscador-btn" onClick={() => setShowResultados(true)}>
            🔍 Buscar
          </button>
          <button className="dt-buscador-btn" onClick={onClose}>
            ❌ Cerrar
          </button>
        </div>
      </div>
      {showResultados && (
        <DTResultados onClose={() => setShowResultados(false)} savedDTs={savedDTs} />
      )}
    </div>,
    document.body
  );
}

export default DTBuscador;
